import { defineNuxtPlugin } from '#app/nuxt'
import { LazyOpportunityCreateDialog, LazyScoresEquation, LazySearchTableCellIndustryFocus, LazySearchTableCellPopup, LazySearchTableCellBenchmark, LazySearchTableCellFlag, LazySearchTableCellLink, LazySearchTableCellScore2decimals, LazySearchTableCellTags, LazySupaAutoExcel, LazySupaAutoMarkdownEditableField, LazySupaAutoFormEntitySearch, LazySupaAutoFormSectionHeadline, LazyVcInvestmentFirmCompetitors, LazyVcInvestmentFirmFunds, LazyVcInvestmentFirmNetwork, LazyVcInvestmentFirmNews, LazyVcInvestmentFirmOverview, LazyVcInvestmentFirmPortfolio, LazyVcInvestmentFirmPortfolioAnalytics, LazyVcInvestmentFirmPortfolioComposition, LazyVcInvestmentFirmTeam } from '#components'
const lazyGlobalComponents = [
  ["OpportunityCreateDialog", LazyOpportunityCreateDialog],
["ScoresEquation", LazyScoresEquation],
["SearchTableCellIndustryFocus", LazySearchTableCellIndustryFocus],
["SearchTableCellPopup", LazySearchTableCellPopup],
["SearchTableCellBenchmark", LazySearchTableCellBenchmark],
["SearchTableCellFlag", LazySearchTableCellFlag],
["SearchTableCellLink", LazySearchTableCellLink],
["SearchTableCellScore2decimals", LazySearchTableCellScore2decimals],
["SearchTableCellTags", LazySearchTableCellTags],
["SupaAutoExcel", LazySupaAutoExcel],
["SupaAutoMarkdownEditableField", LazySupaAutoMarkdownEditableField],
["SupaAutoFormEntitySearch", LazySupaAutoFormEntitySearch],
["SupaAutoFormSectionHeadline", LazySupaAutoFormSectionHeadline],
["VcInvestmentFirmCompetitors", LazyVcInvestmentFirmCompetitors],
["VcInvestmentFirmFunds", LazyVcInvestmentFirmFunds],
["VcInvestmentFirmNetwork", LazyVcInvestmentFirmNetwork],
["VcInvestmentFirmNews", LazyVcInvestmentFirmNews],
["VcInvestmentFirmOverview", LazyVcInvestmentFirmOverview],
["VcInvestmentFirmPortfolio", LazyVcInvestmentFirmPortfolio],
["VcInvestmentFirmPortfolioAnalytics", LazyVcInvestmentFirmPortfolioAnalytics],
["VcInvestmentFirmPortfolioComposition", LazyVcInvestmentFirmPortfolioComposition],
["VcInvestmentFirmTeam", LazyVcInvestmentFirmTeam],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
